// removed by extract-text-webpack-plugin
module.exports = {"button":"subject-controls__button___14FGm","buttonsContainer":"subject-controls__buttonsContainer___1NhXL"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/subjects/subject-controls.css
// module id = 1216
// module chunks = 0